module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "carousel-row"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-slide optimize"
  }, [_c('div', {
    staticClass: "swiper-slide-item"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('div', {
    staticClass: "big-title"
  }, [_vm._v("账户优化-搜索推广效果提升利器")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("账户问题诊断、推荐优化建议、优化效果评估，全面助力搜索推广效果提升")]), _c('a', {
    staticClass: "detail-btn",
    attrs: {
      "href": "/present",
      "target": "_blank"
    }
  }, [_vm._v("查看详情")])])])]), _c('swiper-slide', {
    staticClass: "swiper-slide searchword"
  }, [_c('div', {
    staticClass: "swiper-slide-item"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('div', {
    staticClass: "big-title"
  }, [_vm._v("搜索词报告+落地页分析 助力效果评估")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("新增搜索词、落地页效果数据，丰富搜索推广分析维度")]), _c('a', {
    staticClass: "detail-btn",
    attrs: {
      "href": "/present",
      "target": "_blank"
    }
  }, [_vm._v("查看详情")])])])]), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 1), _vm._m(0), _vm._m(1)], 1), _c('div', {
    staticClass: "row features"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("我们的优势")]), _c('h2', {
    staticClass: "center"
  }, [_vm._v("OUR ADVANTAGES")]), _c('table', {
    staticClass: "features-table"
  }, [_c('tr', _vm._l((_vm.features), function(feature, index) {
    return _c('td', {
      key: index,
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "features-item"
    }, [_c('div', {
      staticClass: "features-img",
      attrs: {
        "id": ("features" + (index + 1) + "-img")
      }
    }), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(feature.title))]), _c('div', {
      staticClass: "features-detail"
    }, [_vm._v(_vm._s(feature.detail))])])])
  }))])]), _c('div', {
    staticClass: "row experience"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("客户使用体验")]), _c('h2', {
    staticClass: "center"
  }, [_vm._v("CUSTOMER EXPERIENCE")]), _c('div', {
    staticClass: "experience-slick"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.clientSwiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "slick-item"
  }, [_c('div', {
    staticClass: "praise disib"
  }, [_vm._v("360分析提供的代码能帮助我们清晰的监测到不同渠道的流量情况，以及不同推广产品所带来的效果，非常直观，极大的提升了我们广告监测效率。")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar circle disib fs16",
    attrs: {
      "src": "https://p4.ssl.qhimg.com/t01f3eaa3c1376194c9.jpg"
    }
  })])])]), _c('swiper-slide', [_c('div', {
    staticClass: "slick-item"
  }, [_c('div', {
    staticClass: "praise disib"
  }, [_vm._v("360分析提供的监测服务和访客跟踪服务帮助我们在投放广告时有效的降低了转化成本，提升了广告效果。")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar circle disib fs16",
    attrs: {
      "src": "https://p2.ssl.qhimg.com/t013f207e546b9896fd.jpg"
    }
  })])])]), _c('swiper-slide', [_c('div', {
    staticClass: "slick-item"
  }, [_c('div', {
    staticClass: "praise disib"
  }, [_vm._v("360分析的代码帮助我们在投放广告时既实现了对访客的再营销，还实现了快速了解转化效果，是一款非常实用的工具。")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar circle disib fs16",
    attrs: {
      "src": "https://p1.ssl.qhimg.com/t0125680e52afbd0c2c.jpg"
    }
  })])])]), _c('swiper-slide', [_c('div', {
    staticClass: "slick-item"
  }, [_c('div', {
    staticClass: "praise disib"
  }, [_vm._v("依托360分析的网站分析功能，我们能够非常清楚的区分不同关键词带来的效果如何，使得我们的账户优化能够有的放矢。")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar circle disib fs16",
    attrs: {
      "src": "https://p2.ssl.qhimg.com/t01d33da035c72beb11.jpg"
    }
  })])])]), _c('swiper-slide', [_c('div', {
    staticClass: "slick-item"
  }, [_c('div', {
    staticClass: "praise disib"
  }, [_vm._v("在360分析的帮助下，我们能够直接看到每天产生了多少订单以及订单的来源，使得我们对于网站的交易情况尽在掌握。")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "avatar circle disib fs16",
    attrs: {
      "src": "https://p1.ssl.qhimg.com/t01b78d90ae89fec0d3.jpg"
    }
  })])])])], 1), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })], 1)]), _c('div', {
    staticClass: "row partner"
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("合作品牌")]), _c('h2', {
    staticClass: "center"
  }, [_vm._v("COOPERATIVE BRAND")]), _c('div', {
    staticClass: "partner-container"
  }, [_vm._l((_vm.partnerSlick.length), function(item, index) {
    return _c('div', {
      staticClass: "partner-item",
      style: ({
        backgroundImage: 'url(' + _vm.partnerSlick.img + ')',
        backgroundPosition: '-0px -' + index * 50 + 'px'
      })
    })
  }), _c('div', {
    staticClass: "little-person"
  })], 2)]), _c('div', {
    staticClass: "ft"
  }, [_c('site-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-button-prev"
  }, [_c('div', {
    staticClass: "swiper-button-arrow swiper-slick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-button-next"
  }, [_c('div', {
    staticClass: "swiper-button-arrow swiper-slick"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c7bf1654", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7bf1654!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
// module id = 798
// module chunks = 0